// @flow

import {
  FARM,
  FIELD,
} from 'fc-model-assets'

// Utils
import traverse from 'fc-utils/traverse'

// Libs
import { createSelector } from 'reselect'

// Local
const path$ = traverse(['router', 'location', 'pathname'])

export default createSelector(
  [path$],
  function (path: string): ?string {
    const match = `${path || ''}`.match(/assets\/(farms|fields)/)

    if (match && match.length > 1) {
      const category = match[1]

      if (category === 'farms') {
        return FARM
      } else if (category === 'fields') {
        return FIELD
      }
    }

    return null
  }
)
